export default __webpack_public_path__ + "static/media/plain-sticker-tr.2b0ad505.png";